import React from 'react'

const styles = {width: '99vw', height: '88vh'};


function ManejoPlantas() {
    return (
        <iframe 
        src="https://geologiaconce.maps.arcgis.com/apps/dashboards/b7f8f45bf098402dbfa77a5d2610158c"
        style={styles}>
        </iframe>
    )
}

export default ManejoPlantas
